export const AutogeneratedTableLookup = {
   "library" : {
      "annotation" : [ {
         "translatorOptions" : "",
         "type" : "CqlToElmInfo"
      } ],
      "identifier" : {
         "id" : "AutogeneratedTableLookup",
         "version" : "1.0.0"
      },
      "schemaIdentifier" : {
         "id" : "urn:hl7-org:elm",
         "version" : "r1"
      },
      "usings" : {
         "def" : [ {
            "localIdentifier" : "System",
            "uri" : "urn:hl7-org:elm-types:r1"
         }, {
            "localIdentifier" : "FHIR",
            "uri" : "http://hl7.org/fhir",
            "version" : "4.0.1"
         } ]
      },
      "includes" : {
         "def" : [ {
            "localIdentifier" : "FHIRHelpers",
            "path" : "FHIRHelpers",
            "version" : "4.0.1"
         }, {
            "localIdentifier" : "RiskTables",
            "path" : "AutogeneratedRiskTables",
            "version" : "1.0.0"
         } ]
      },
      "statements" : {
         "def" : [ {
            "name" : "GeneralScreeningTable",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GeneralScreening",
               "libraryName" : "RiskTables",
               "type" : "ExpressionRef"
            }
         }, {
            "name" : "SurveillanceTable",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "Surveillance",
               "libraryName" : "RiskTables",
               "type" : "ExpressionRef"
            }
         }, {
            "name" : "ColposcopyResultsTable",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "ColposcopyResults",
               "libraryName" : "RiskTables",
               "type" : "ExpressionRef"
            }
         }, {
            "name" : "PostColposcopyTable",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "PostColposcopy",
               "libraryName" : "RiskTables",
               "type" : "ExpressionRef"
            }
         }, {
            "name" : "PostTreatmentTable",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "PostTreatment",
               "libraryName" : "RiskTables",
               "type" : "ExpressionRef"
            }
         }, {
            "name" : "HighGradePap",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Or",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currPapVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "ASC-H",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currPapVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "AGC",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "HSIL+",
                           "type" : "Literal"
                        } ]
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "High Grade",
                  "type" : "Literal"
               },
               "else" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "NULL",
                  "type" : "Literal"
               }
            },
            "operand" : [ {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "ScreeningText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "cytoResult",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "ALL",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "cytoResult",
                           "type" : "OperandRef"
                        }
                     } ]
                  }
               },
               "then" : {
                  "type" : "If",
                  "condition" : {
                     "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                     "type" : "As",
                     "operand" : {
                        "type" : "Not",
                        "operand" : {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "hpvResult",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "ALL",
                              "type" : "Literal"
                           } ]
                        }
                     }
                  },
                  "then" : {
                     "name" : "hpvResult",
                     "type" : "OperandRef"
                  },
                  "else" : {
                     "name" : "noHistoryString",
                     "type" : "OperandRef"
                  }
               },
               "else" : {
                  "type" : "If",
                  "condition" : {
                     "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                     "type" : "As",
                     "operand" : {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "cytoResult",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "NILM",
                           "type" : "Literal"
                        } ]
                     }
                  },
                  "then" : {
                     "type" : "If",
                     "condition" : {
                        "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                        "type" : "As",
                        "operand" : {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "hpvResult",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        }
                     },
                     "then" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     },
                     "else" : {
                        "type" : "If",
                        "condition" : {
                           "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                           "type" : "As",
                           "operand" : {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "hpvResult",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "HPV-positive",
                                 "type" : "Literal"
                              } ]
                           }
                        },
                        "then" : {
                           "type" : "Concatenate",
                           "operand" : [ {
                              "type" : "Concatenate",
                              "operand" : [ {
                                 "name" : "hpvResult",
                                 "type" : "OperandRef"
                              }, {
                                 "name" : "spacerString",
                                 "type" : "OperandRef"
                              } ]
                           }, {
                              "name" : "cytoResult",
                              "type" : "OperandRef"
                           } ]
                        },
                        "else" : {
                           "name" : "noHistoryString",
                           "type" : "OperandRef"
                        }
                     }
                  },
                  "else" : {
                     "type" : "If",
                     "condition" : {
                        "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                        "type" : "As",
                        "operand" : {
                           "type" : "Not",
                           "operand" : {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "hpvResult",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "ALL",
                                 "type" : "Literal"
                              } ]
                           }
                        }
                     },
                     "then" : {
                        "type" : "Concatenate",
                        "operand" : [ {
                           "type" : "Concatenate",
                           "operand" : [ {
                              "name" : "hpvResult",
                              "type" : "OperandRef"
                           }, {
                              "name" : "spacerString",
                              "type" : "OperandRef"
                           } ]
                        }, {
                           "name" : "cytoResult",
                           "type" : "OperandRef"
                        } ]
                     },
                     "else" : {
                        "name" : "noHistoryString",
                        "type" : "OperandRef"
                     }
                  }
               }
            },
            "operand" : [ {
               "name" : "hpvResult",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "cytoResult",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "spacerString",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "noHistoryString",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetRowTable1",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Coalesce",
               "operand" : [ {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "GeneralScreeningTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "ScreeningText",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "name" : "prevPapVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "/",
                                    "type" : "Literal"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "NO HISTORY",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "currHpvVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "pap",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "currPapVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "path" : "immediate",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "path" : "five_year",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               }, {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "GeneralScreeningTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "ScreeningText",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "name" : "prevPapVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "/",
                                    "type" : "Literal"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "NO HISTORY",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "currHpvVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "pap",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "HighGradePap",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "path" : "immediate",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "path" : "five_year",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               } ]
            },
            "operand" : [ {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetGeneralScreeningManagement",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "R",
                  "expression" : {
                     "name" : "GetRowTable1",
                     "type" : "FunctionRef",
                     "operand" : [ {
                        "name" : "prevHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevPapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currPapVal",
                        "type" : "OperandRef"
                     } ]
                  }
               } ],
               "relationship" : [ ],
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "action",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "riskNow",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "risk5yr",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetAdjacentRowsTable1",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "T",
                  "expression" : {
                     "name" : "GeneralScreeningTable",
                     "type" : "ExpressionRef"
                  }
               } ],
               "relationship" : [ ],
               "where" : {
                  "type" : "And",
                  "operand" : [ {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "history",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "ScreeningText",
                           "type" : "FunctionRef",
                           "operand" : [ {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "name" : "prevPapVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "/",
                              "type" : "Literal"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "NO HISTORY",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "currHpvVal",
                           "type" : "OperandRef"
                        } ]
                     } ]
                  }, {
                     "type" : "Not",
                     "operand" : {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        } ]
                     }
                  } ]
               },
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "management",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "history",
                        "value" : {
                           "path" : "history",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "prev2",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev1",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "referral",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "biopsy",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "hpv",
                        "value" : {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "cyto",
                        "value" : {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "immediate",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "five_year",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "AscusAlternativeSpelling",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "ascus",
                        "type" : "OperandRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "ASC_US",
                  "type" : "Literal"
               },
               "else" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "NULL",
                  "type" : "Literal"
               }
            },
            "operand" : [ {
               "name" : "ascus",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "HighGradeOrAscusLsilPap",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "ASC-US",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "LSIL",
                           "type" : "Literal"
                        } ]
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "ASC-US, LSIL",
                  "type" : "Literal"
               },
               "else" : {
                  "type" : "If",
                  "condition" : {
                     "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                     "type" : "As",
                     "operand" : {
                        "type" : "Or",
                        "operand" : [ {
                           "type" : "Or",
                           "operand" : [ {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "ASC-H",
                                 "type" : "Literal"
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "AGC",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currPapVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HSIL+",
                              "type" : "Literal"
                           } ]
                        } ]
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "High Grade",
                     "type" : "Literal"
                  },
                  "else" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "NULL",
                     "type" : "Literal"
                  }
               }
            },
            "operand" : [ {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "hpv18PlusAlternativeSpelling",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "hpv18",
                        "type" : "OperandRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "HPV16-,18+",
                  "type" : "Literal"
               },
               "else" : {
                  "name" : "hpv18",
                  "type" : "OperandRef"
               }
            },
            "operand" : [ {
               "name" : "hpv18",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "historyLeadingSpace",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "history",
                        "type" : "OperandRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : " Cotest-negative",
                  "type" : "Literal"
               },
               "else" : {
                  "name" : "history",
                  "type" : "OperandRef"
               }
            },
            "operand" : [ {
               "name" : "history",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetRowTable2",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Coalesce",
               "operand" : [ {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "SurveillanceTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history_prev_2",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "ScreeningText",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "/",
                                       "type" : "Literal"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "none",
                                       "type" : "Literal"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "historyLeadingSpace",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "ScreeningText",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "/",
                                          "type" : "Literal"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "none",
                                          "type" : "Literal"
                                       } ]
                                    } ]
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "hpv18PlusAlternativeSpelling",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "pap",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "currPapVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "path" : "history_prev_2",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "path" : "immediate",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "path" : "five_year",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               }, {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "SurveillanceTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history_prev_2",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "ScreeningText",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "/",
                                       "type" : "Literal"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "none",
                                       "type" : "Literal"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "historyLeadingSpace",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "ScreeningText",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "/",
                                          "type" : "Literal"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "none",
                                          "type" : "Literal"
                                       } ]
                                    } ]
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "hpv18PlusAlternativeSpelling",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "pap",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "AscusAlternativeSpelling",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "path" : "history_prev_2",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "path" : "immediate",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "path" : "five_year",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               }, {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "SurveillanceTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history_prev_2",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "ScreeningText",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "/",
                                       "type" : "Literal"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "none",
                                       "type" : "Literal"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "historyLeadingSpace",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "ScreeningText",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "/",
                                          "type" : "Literal"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "none",
                                          "type" : "Literal"
                                       } ]
                                    } ]
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "hpv18PlusAlternativeSpelling",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "pap",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "HighGradeOrAscusLsilPap",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "path" : "history_prev_2",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "path" : "immediate",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "path" : "five_year",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               }, {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "SurveillanceTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history_prev_2",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "ScreeningText",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "/",
                                       "type" : "Literal"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "none",
                                       "type" : "Literal"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "history",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "historyLeadingSpace",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "ScreeningText",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "/",
                                          "type" : "Literal"
                                       }, {
                                          "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                          "value" : "none",
                                          "type" : "Literal"
                                       } ]
                                    } ]
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "hpv18PlusAlternativeSpelling",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "pap",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "ALL",
                              "type" : "Literal"
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "path" : "history_prev_2",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "path" : "history",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "path" : "hpv",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "path" : "immediate",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "path" : "five_year",
                                 "type" : "Property",
                                 "source" : {
                                    "path" : "value",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               } ]
            },
            "operand" : [ {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetSurveillanceManagement",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "R",
                  "expression" : {
                     "name" : "GetRowTable2",
                     "type" : "FunctionRef",
                     "operand" : [ {
                        "name" : "prev2HpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prev2PapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevPapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currPapVal",
                        "type" : "OperandRef"
                     } ]
                  }
               } ],
               "relationship" : [ ],
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "action",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "riskNow",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "risk5yr",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetAdjacentRowsTable2",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "T",
                  "expression" : {
                     "name" : "SurveillanceTable",
                     "type" : "ExpressionRef"
                  }
               } ],
               "relationship" : [ ],
               "where" : {
                  "type" : "And",
                  "operand" : [ {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "history_prev_2",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "ScreeningText",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }, {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "/",
                                 "type" : "Literal"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "none",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "history",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "historyLeadingSpace",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "ScreeningText",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "name" : "prevPapVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "/",
                                    "type" : "Literal"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "none",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "hpv18PlusAlternativeSpelling",
                           "type" : "FunctionRef",
                           "operand" : [ {
                              "name" : "currHpvVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     } ]
                  }, {
                     "type" : "Not",
                     "operand" : {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        } ]
                     }
                  } ]
               },
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "management",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "history",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev2",
                        "value" : {
                           "path" : "history_prev_2",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "prev1",
                        "value" : {
                           "path" : "history",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "referral",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "biopsy",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "hpv",
                        "value" : {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "cyto",
                        "value" : {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "immediate",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "five_year",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "AnyHpv",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "hpvVal",
                        "type" : "OperandRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "HPV-positive",
                  "type" : "Literal"
               },
               "else" : {
                  "type" : "If",
                  "condition" : {
                     "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                     "type" : "As",
                     "operand" : {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "hpvVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "HPV16-, HPV18+",
                           "type" : "Literal"
                        } ]
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "HPV-positive",
                     "type" : "Literal"
                  },
                  "else" : {
                     "name" : "hpvVal",
                     "type" : "OperandRef"
                  }
               }
            },
            "operand" : [ {
               "name" : "hpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetRowTable3",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Coalesce",
               "operand" : [ {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "ColposcopyResultsTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "referral_screen_result",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "ScreeningText",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "AnyHpv",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "preBiopsyHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              }, {
                                 "name" : "preBiopsyPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : " ",
                                 "type" : "Literal"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "none",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "biopsy",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "biopsyVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "path" : "referral_screen_result",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "path" : "biopsy",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "type" : "ToDecimal",
                                 "operand" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "type" : "ToDecimal",
                                 "operand" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               }, {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "ColposcopyResultsTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "referral_screen_result",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "preBiopsyPapVal",
                              "type" : "OperandRef"
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "biopsy",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "biopsyVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "path" : "referral_screen_result",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "path" : "biopsy",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "type" : "ToDecimal",
                                 "operand" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "type" : "ToDecimal",
                                 "operand" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               }, {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "T",
                        "expression" : {
                           "name" : "ColposcopyResultsTable",
                           "type" : "ExpressionRef"
                        }
                     } ],
                     "relationship" : [ ],
                     "where" : {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "referral_screen_result",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "none",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "biopsy",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "biopsyVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     },
                     "return" : {
                        "expression" : {
                           "type" : "Tuple",
                           "element" : [ {
                              "name" : "action",
                              "value" : {
                                 "path" : "management",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "history",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev2",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "prev1",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "referral",
                              "value" : {
                                 "path" : "referral_screen_result",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "biopsy",
                              "value" : {
                                 "path" : "biopsy",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }, {
                              "name" : "preColposcopyResult",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "postColposcopyPastHistory",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "hpv",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "cyto",
                              "value" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "",
                                 "type" : "Literal"
                              }
                           }, {
                              "name" : "riskNow",
                              "value" : {
                                 "type" : "ToDecimal",
                                 "operand" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }
                           }, {
                              "name" : "risk5yr",
                              "value" : {
                                 "type" : "ToDecimal",
                                 "operand" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }
                           } ]
                        }
                     }
                  } ]
               } ]
            },
            "operand" : [ {
               "name" : "preBiopsyHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "preBiopsyPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetColposcopyResultsManagement",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "R",
                  "expression" : {
                     "name" : "GetRowTable3",
                     "type" : "FunctionRef",
                     "operand" : [ {
                        "name" : "preBiopsyHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "preBiopsyPapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "biopsyVal",
                        "type" : "OperandRef"
                     } ]
                  }
               } ],
               "relationship" : [ ],
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "action",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "riskNow",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "risk5yr",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "preBiopsyHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "preBiopsyPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetAdjacentRowsTable3",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "T",
                  "expression" : {
                     "name" : "ColposcopyResultsTable",
                     "type" : "ExpressionRef"
                  }
               } ],
               "relationship" : [ ],
               "where" : {
                  "type" : "And",
                  "operand" : [ {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Not",
                        "operand" : {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "referral_screen_result",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "ScreeningText",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "AnyHpv",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "preBiopsyHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              }, {
                                 "name" : "preBiopsyPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : " ",
                                 "type" : "Literal"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "none",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }
                     }, {
                        "type" : "Not",
                        "operand" : {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "referral_screen_result",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "biopsyVal",
                              "type" : "OperandRef"
                           } ]
                        }
                     } ]
                  }, {
                     "type" : "Equal",
                     "operand" : [ {
                        "path" : "biopsy",
                        "scope" : "T",
                        "type" : "Property"
                     }, {
                        "name" : "biopsyVal",
                        "type" : "OperandRef"
                     } ]
                  } ]
               },
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "management",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "history",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev2",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev1",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "referral",
                        "value" : {
                           "path" : "referral_screen_result",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "biopsy",
                        "value" : {
                           "path" : "biopsy",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "hpv",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "cyto",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "type" : "ToDecimal",
                           "operand" : {
                              "path" : "immediate",
                              "type" : "Property",
                              "source" : {
                                 "path" : "value",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "type" : "ToDecimal",
                           "operand" : {
                              "path" : "five_year",
                              "type" : "Property",
                              "source" : {
                                 "path" : "value",
                                 "scope" : "T",
                                 "type" : "Property"
                              }
                           }
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "preBiopsyHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "preBiopsyPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "HighOrLowGradeResults",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "hpvVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "HPV-positive",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "papVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "NILM",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Low Grade",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "papVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "ASC-US",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "papVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "LSIL",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Low Grade",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Or",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "papVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "ASC-H",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "papVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "AGC",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "papVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "HSIL+",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "High Grade",
                     "type" : "Literal"
                  }
               } ],
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            },
            "operand" : [ {
               "name" : "hpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "papVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "PostColposcopyPastHistory",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }
                           }, {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }
                           } ]
                        }, {
                           "type" : "IsNull",
                           "operand" : {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }
                        } ]
                     }, {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "none",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }
                           }, {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "NILM",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Cotest-negative",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }
                           }, {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Or",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevPapVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "ASC-US",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevPapVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "LSIL",
                              "type" : "Literal"
                           } ]
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : " HPV-negative/ASCUS/LSIL",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }
                           }, {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "HPV-negative",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "HPV-negative",
                                 "type" : "Literal"
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "NILM",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "NILM",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Cotest-negative x2",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "HPV-negative",
                                 "type" : "Literal"
                              } ]
                           }, {
                              "type" : "IsNull",
                              "operand" : {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "HPV-negative x2",
                     "type" : "Literal"
                  }
               } ],
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            },
            "operand" : [ {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "AscusLsilPap",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "ASC-US",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "LSIL",
                           "type" : "Literal"
                        } ]
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "ASC-US/LSIL",
                  "type" : "Literal"
               },
               "else" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "NULL",
                  "type" : "Literal"
               }
            },
            "operand" : [ {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetRowTable4",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "biopsyVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "<CIN1",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "biopsyVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "CIN1",
                           "type" : "Literal"
                        } ]
                     } ]
                  }
               },
               "then" : {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostColposcopyTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "preColposcopyResult",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "HighOrLowGradeResults",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "preBiopsyHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "preBiopsyPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 }, {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "postColposcopyPastHistory",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "PostColposcopyPastHistory",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prev2HpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prev2PapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "path" : "preColposcopyResult",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "path" : "postColposcopyPastHistory",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  }, {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostColposcopyTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "preColposcopyResult",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "HighOrLowGradeResults",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "preBiopsyHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "preBiopsyPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 }, {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "postColposcopyPastHistory",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "PostColposcopyPastHistory",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prev2HpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prev2PapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "HighOrLowGradeResults",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "name" : "currPapVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "path" : "preColposcopyResult",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "path" : "postColposcopyPastHistory",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  }, {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostColposcopyTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "preColposcopyResult",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "HighOrLowGradeResults",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "preBiopsyHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "preBiopsyPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 }, {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "postColposcopyPastHistory",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "PostColposcopyPastHistory",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prev2HpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prev2PapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "AscusLsilPap",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currPapVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "path" : "preColposcopyResult",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "path" : "postColposcopyPastHistory",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  }, {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostColposcopyTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "preColposcopyResult",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "HighOrLowGradeResults",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "preBiopsyHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "preBiopsyPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 }, {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "path" : "postColposcopyPastHistory",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }, {
                                       "name" : "PostColposcopyPastHistory",
                                       "type" : "FunctionRef",
                                       "operand" : [ {
                                          "name" : "prev2HpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prev2PapVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevHpvVal",
                                          "type" : "OperandRef"
                                       }, {
                                          "name" : "prevPapVal",
                                          "type" : "OperandRef"
                                       } ]
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "ALL",
                                 "type" : "Literal"
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "path" : "preColposcopyResult",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "path" : "postColposcopyPastHistory",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  } ]
               },
               "else" : {
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  },
                  "asTypeSpecifier" : {
                     "type" : "TupleTypeSpecifier",
                     "element" : [ {
                        "name" : "action",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "history",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "prev2",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "prev1",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "referral",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "biopsy",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "hpv",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "cyto",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "riskNow",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "risk5yr",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                           "type" : "NamedTypeSpecifier"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "preBiopsyHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "preBiopsyPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetPostColposcopyManagement",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "R",
                  "expression" : {
                     "name" : "GetRowTable4",
                     "type" : "FunctionRef",
                     "operand" : [ {
                        "name" : "preBiopsyHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "preBiopsyPapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "biopsyVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prev2HpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prev2PapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevPapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currPapVal",
                        "type" : "OperandRef"
                     } ]
                  }
               } ],
               "relationship" : [ ],
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "action",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "riskNow",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "risk5yr",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "preBiopsyHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "preBiopsyPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetAdjacentRowsTable4",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "T",
                  "expression" : {
                     "name" : "PostColposcopyTable",
                     "type" : "ExpressionRef"
                  }
               } ],
               "relationship" : [ ],
               "where" : {
                  "type" : "And",
                  "operand" : [ {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "preColposcopyResult",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "HighOrLowGradeResults",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "preBiopsyHpvVal",
                                 "type" : "OperandRef"
                              }, {
                                 "name" : "preBiopsyPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "path" : "postColposcopyPastHistory",
                              "scope" : "T",
                              "type" : "Property"
                           }, {
                              "name" : "PostColposcopyPastHistory",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "prev2HpvVal",
                                 "type" : "OperandRef"
                              }, {
                                 "name" : "prev2PapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "name" : "prevHpvVal",
                                 "type" : "OperandRef"
                              }, {
                                 "name" : "prevPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "currHpvVal",
                           "type" : "OperandRef"
                        } ]
                     } ]
                  }, {
                     "type" : "Not",
                     "operand" : {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        } ]
                     }
                  } ]
               },
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "management",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "value" : {
                           "path" : "preColposcopyResult",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "value" : {
                           "path" : "postColposcopyPastHistory",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "history",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev2",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev1",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "referral",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "biopsy",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "hpv",
                        "value" : {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "cyto",
                        "value" : {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "immediate",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "five_year",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "preBiopsyHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "preBiopsyPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "TreatCin2AndCin3TheSame",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "biopsyVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "CIN2",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "biopsyVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "CIN3",
                           "type" : "Literal"
                        } ]
                     } ]
                  }
               },
               "then" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "CIN3",
                  "type" : "Literal"
               },
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            },
            "operand" : [ {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "LongTermSurveillance",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "HPV-negative",
                                       "type" : "Literal"
                                    } ]
                                 }, {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "ALL",
                                       "type" : "Literal"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "HPV-negative",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prevPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "ALL",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "ALL",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "HPV-negative x3",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "HPV-negative",
                                       "type" : "Literal"
                                    } ]
                                 }, {
                                    "type" : "Equal",
                                    "operand" : [ {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                       "value" : "NILM",
                                       "type" : "Literal"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "HPV-negative",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prevPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "NILM",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "NILM",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Cotest-negative x3",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "IsNull",
                                    "operand" : {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }
                                 }, {
                                    "type" : "IsNull",
                                    "operand" : {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "HPV-negative",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prevPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "ALL",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "ALL",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "HPV-negative x2",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "And",
                                 "operand" : [ {
                                    "type" : "IsNull",
                                    "operand" : {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }
                                 }, {
                                    "type" : "IsNull",
                                    "operand" : {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "name" : "prevHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "HPV-negative",
                                    "type" : "Literal"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "name" : "prevPapVal",
                                 "type" : "OperandRef"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "NILM",
                                 "type" : "Literal"
                              } ]
                           } ]
                        }, {
                           "type" : "Equal",
                           "operand" : [ {
                              "name" : "currHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}String",
                              "value" : "HPV-negative",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "prevPapVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "NILM",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Cotest-negative x2",
                     "type" : "Literal"
                  }
               } ],
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            },
            "operand" : [ {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetRowTable5",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Or",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "biopsyVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "CIN2",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "biopsyVal",
                           "type" : "OperandRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "CIN3",
                           "type" : "Literal"
                        } ]
                     } ]
                  }
               },
               "then" : {
                  "type" : "Coalesce",
                  "operand" : [ {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostTreatmentTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "TreatCin2AndCin3TheSame",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "biopsyVal",
                                       "type" : "OperandRef"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "LongTermSurveillance",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "prev2HpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prev2PapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prevHpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "prevPapVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "currHpvVal",
                                       "type" : "OperandRef"
                                    }, {
                                       "name" : "currPapVal",
                                       "type" : "OperandRef"
                                    } ]
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                 "value" : "none",
                                 "type" : "Literal"
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  }, {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostTreatmentTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "TreatCin2AndCin3TheSame",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "biopsyVal",
                                       "type" : "OperandRef"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "currPapVal",
                                 "type" : "OperandRef"
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  }, {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostTreatmentTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "TreatCin2AndCin3TheSame",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "biopsyVal",
                                       "type" : "OperandRef"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "HighOrLowGradeResults",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 }, {
                                    "name" : "currPapVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  }, {
                     "type" : "Coalesce",
                     "operand" : [ {
                        "type" : "Query",
                        "source" : [ {
                           "alias" : "T",
                           "expression" : {
                              "name" : "PostTreatmentTable",
                              "type" : "ExpressionRef"
                           }
                        } ],
                        "relationship" : [ ],
                        "where" : {
                           "type" : "And",
                           "operand" : [ {
                              "type" : "And",
                              "operand" : [ {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "TreatCin2AndCin3TheSame",
                                    "type" : "FunctionRef",
                                    "operand" : [ {
                                       "name" : "biopsyVal",
                                       "type" : "OperandRef"
                                    } ]
                                 } ]
                              }, {
                                 "type" : "Equal",
                                 "operand" : [ {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }, {
                                    "name" : "currHpvVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           }, {
                              "type" : "Equal",
                              "operand" : [ {
                                 "path" : "pap",
                                 "scope" : "T",
                                 "type" : "Property"
                              }, {
                                 "name" : "AscusLsilPap",
                                 "type" : "FunctionRef",
                                 "operand" : [ {
                                    "name" : "currPapVal",
                                    "type" : "OperandRef"
                                 } ]
                              } ]
                           } ]
                        },
                        "return" : {
                           "expression" : {
                              "type" : "Tuple",
                              "element" : [ {
                                 "name" : "action",
                                 "value" : {
                                    "path" : "management",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "history",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev2",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "prev1",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "preColposcopyResult",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "postColposcopyPastHistory",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "referral",
                                 "value" : {
                                    "valueType" : "{urn:hl7-org:elm-types:r1}String",
                                    "value" : "",
                                    "type" : "Literal"
                                 }
                              }, {
                                 "name" : "biopsy",
                                 "value" : {
                                    "path" : "biopsy",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "hpv",
                                 "value" : {
                                    "path" : "hpv",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "cyto",
                                 "value" : {
                                    "path" : "pap",
                                    "scope" : "T",
                                    "type" : "Property"
                                 }
                              }, {
                                 "name" : "riskNow",
                                 "value" : {
                                    "path" : "immediate",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              }, {
                                 "name" : "risk5yr",
                                 "value" : {
                                    "path" : "five_year",
                                    "type" : "Property",
                                    "source" : {
                                       "path" : "value",
                                       "scope" : "T",
                                       "type" : "Property"
                                    }
                                 }
                              } ]
                           }
                        }
                     } ]
                  } ]
               },
               "else" : {
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  },
                  "asTypeSpecifier" : {
                     "type" : "TupleTypeSpecifier",
                     "element" : [ {
                        "name" : "action",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "history",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "prev2",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "prev1",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "referral",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "biopsy",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "hpv",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "cyto",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "riskNow",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "risk5yr",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                           "type" : "NamedTypeSpecifier"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetPostTreatmentManagement",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "R",
                  "expression" : {
                     "name" : "GetRowTable5",
                     "type" : "FunctionRef",
                     "operand" : [ {
                        "name" : "biopsyVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prev2HpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prev2PapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "prevPapVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currHpvVal",
                        "type" : "OperandRef"
                     }, {
                        "name" : "currPapVal",
                        "type" : "OperandRef"
                     } ]
                  }
               } ],
               "relationship" : [ ],
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "action",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "riskNow",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "risk5yr",
                           "scope" : "R",
                           "type" : "Property"
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         }, {
            "name" : "GetAdjacentRowsTable5",
            "context" : "Patient",
            "accessLevel" : "Public",
            "type" : "FunctionDef",
            "expression" : {
               "type" : "Query",
               "source" : [ {
                  "alias" : "T",
                  "expression" : {
                     "name" : "PostTreatmentTable",
                     "type" : "ExpressionRef"
                  }
               } ],
               "relationship" : [ ],
               "where" : {
                  "type" : "And",
                  "operand" : [ {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "biopsy",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "TreatCin2AndCin3TheSame",
                           "type" : "FunctionRef",
                           "operand" : [ {
                              "name" : "biopsyVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "LongTermSurveillance",
                           "type" : "FunctionRef",
                           "operand" : [ {
                              "name" : "prev2HpvVal",
                              "type" : "OperandRef"
                           }, {
                              "name" : "prev2PapVal",
                              "type" : "OperandRef"
                           }, {
                              "name" : "prevHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "name" : "prevPapVal",
                              "type" : "OperandRef"
                           }, {
                              "name" : "currHpvVal",
                              "type" : "OperandRef"
                           }, {
                              "name" : "currPapVal",
                              "type" : "OperandRef"
                           } ]
                        } ]
                     } ]
                  }, {
                     "type" : "Not",
                     "operand" : {
                        "type" : "Equal",
                        "operand" : [ {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }, {
                           "name" : "currPapVal",
                           "type" : "OperandRef"
                        } ]
                     }
                  } ]
               },
               "return" : {
                  "expression" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "action",
                        "value" : {
                           "path" : "management",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "history",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev2",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "prev1",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "referral",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "biopsy",
                        "value" : {
                           "path" : "biopsy",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "hpv",
                        "value" : {
                           "path" : "hpv",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "cyto",
                        "value" : {
                           "path" : "pap",
                           "scope" : "T",
                           "type" : "Property"
                        }
                     }, {
                        "name" : "riskNow",
                        "value" : {
                           "path" : "immediate",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     }, {
                        "name" : "risk5yr",
                        "value" : {
                           "path" : "five_year",
                           "type" : "Property",
                           "source" : {
                              "path" : "value",
                              "scope" : "T",
                              "type" : "Property"
                           }
                        }
                     } ]
                  }
               }
            },
            "operand" : [ {
               "name" : "biopsyVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2HpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prev2PapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "prevPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currHpvVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            }, {
               "name" : "currPapVal",
               "operandTypeSpecifier" : {
                  "name" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "NamedTypeSpecifier"
               }
            } ]
         } ]
      }
   }
}

